import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { StudentChatWorkspace } from '@/features/chat/components/StudentChatWorkspace';

/**
 * Two-pane messenger driven entirely by search params, mirroring the sessions
 * workspace: `chat` selects the open conversation, `compose` opens the warm
 * New-chat entry. Opening a chat drops `compose` so the two are never both set.
 */
const chatSearchSchema = z
  .object({
    chat: z.string().optional().catch(undefined),
    compose: z.boolean().optional().catch(undefined),
  })
  .transform((v) => (v.chat ? { chat: v.chat, compose: undefined } : v));

export type ClientChatSearch = z.infer<typeof chatSearchSchema>;

export const Route = createFileRoute('/client/chat/')({
  validateSearch: chatSearchSchema,
  component: StudentChatWorkspace,
  staticData: { crumb: 'Chat' },
});
